import React from 'react';
import { Link } from '@inertiajs/react';
import { Play, Move3d, ArrowRight } from 'lucide-react';
import './VirtualTourHighlight.css';

const VirtualTourHighlight = () => {
    return (
        <section className="virtual-tour-highlight">
            {/* Decorative nature elements */}
            <div className="vth-nature-decoration vth-leaf-1">🍃</div>
            <div className="vth-nature-decoration vth-flower-1">🌸</div>

            <div className="vth-container">
                <div className="vth-content">
                    <div className="vth-badge">
                        <Move3d size={18} />
                        <span>Interactive experience</span>
                    </div>
                    <h2>Step Inside Hollywood Royale</h2>
                    <p>
                        Experience our community from anywhere. Take a self-guided virtual walkthrough of our luxury amenities, comfortable living spaces, and beautiful gardens.
                    </p>
                    <Link href="/virtual-tour" className="vth-button">
                        Start Virtual Tour <ArrowRight size={18} />
                    </Link>
                </div>

                <div className="vth-visual">
                    <Link href="/virtual-tour">
                        <div className="vth-image-wrapper">
                            <img
                                src="/IMG_9046.jpg"
                                alt="Virtual Tour Preview of Hollywood Royale Garden"
                                loading="lazy"
                            />
                            <div className="vth-play-overlay">
                                <div className="vth-play-button">
                                    <Play size={32} fill="currentColor" />
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default VirtualTourHighlight;
